module.exports = __webpack_public_path__ + "assets/img/case1.733f5f23.png";